import { Lesson } from '@/models/Lesson';
import { AddToListRequest } from '@/models/List';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { ListItemsTypes } from './types';

export const addItemsToListRequest = (data: { payload: AddToListRequest[]; willPublish: boolean; listId: number; history: any }) =>
    action(ListItemsTypes.ADD_TO_LIST_REQUEST, data);
export const addItemsToListSuccess = () => action(ListItemsTypes.ADD_TO_LIST_SUCCESS);
export const addItemsToListFailure = (error: AxiosError) => action(ListItemsTypes.ADD_TO_LIST_FAILURE, error);
export const addItemsToListClear = () => action(ListItemsTypes.ADD_TO_LIST_CLEAR);

export const deleteItemFromListRequest = (data: { lessonId: number; listId: number | undefined }) =>
    action(ListItemsTypes.DELETE_FROM_LIST_REQUEST, data);
export const deleteItemFromListSuccess = (lessonId: number) => action(ListItemsTypes.DELETE_FROM_LIST_SUCCESS, lessonId);
export const deleteItemFromListFailure = (error: AxiosError) => action(ListItemsTypes.DELETE_FROM_LIST_FAILURE, error);
export const deleteItemFromListClear = () => action(ListItemsTypes.DELETE_FROM_LIST_CLEAR);

export const getListItemsRequest = (data: number) => action(ListItemsTypes.GET_LIST_ITEMS_REQUEST, data);
export const getListItemsSuccess = (data: Lesson[]) => action(ListItemsTypes.GET_LIST_ITEMS_SUCCESS, data);
export const getListItemsFailure = (error: AxiosError) => action(ListItemsTypes.GET_LIST_ITEMS_FAILURE, error);
export const listItemsClear = () => action(ListItemsTypes.LIST_ITEMS_CLEAR);
